import { EAGAIN } from 'constants';
import { LogoutService } from '../header/usersettings/logout.service';
/**
 * Constants for the messages to be displayed across application.
 */
export class MessageService {

    //Generic error message.
    public static GENERIC_ERROR = 'Error ocurred while processing the request.';

    // Messages for Create Person Component.
    public static CREATE_PERSON_SUCCESS = 'Person created successfully.';
    public static CREATE_PERSON_FAILURE = 'Unable to create person. Please try again.';
    public static UPDATE_PERSON_SUCCESS = 'Person details updated successfully.';
    public static UPDATE_PERSON_FAILURE = 'Unable to update person details. Please try again.';

    // Messages for Generic Search Component.
    public static GENERIC_SEARCH_FAILURE = 'Unable to search. Please try again.';

    // Messages for Create Organisation Component.
    public static CREATE_ORG_SUCCESS = 'Organisation created successfully.';
    public static CREATE_ORG_FAILURE = 'Unable to create organisation. Please try again.';

    // Messages for Change Password Component.
    public static RESET_USER_PASSWORD_ALERT = 'Are you sure you want to reset the user password?';
    public static CHANGE_PASSWORD_SUCCESS = 'Person changed successfully.';
    public static CHANGE_PASSWORD_FAILURE = 'Unable to change password. Please try again.';

    // Messages for User Preferences Component.
    public static SAVE_PREFERENCES_SUCCESS = 'Preferences saved successfully.';
    public static SAVE_PREFERENCES_FAILURE = 'Unable to save preferences. Please try again.';
    public static RESET_USER_PREFERENCES_ALERT = 'Are you sure you want to reset the user preferences?';
    public static UNSAVED_FORM_ALERT = 'There are some unsaved changes. Do you want to leave this page?';
    public static AUTO_DETECT_EWS_URL_SUCCESS = 'Fetched Exchange EWS URL successfully.';
    public static AUTO_DETECT_EWS_URL_FAILURE = 'Unable to fetch Exchange EWS URL successfully.';
    public static MAILBOX_TAB_CHANGE_ALERT = 'Either of Microsoft Exchange EWS, POP or IMAP can'
        + 'be configured.\r\nAre you sure, you want to discard unsaved data and move to another setting?';

    // Messages for Legal Structure Component.
    public static CREATE_LEGAL_STRUCTURE_SUCCESS = 'Legal structure created successfully.';
    public static CREATE_LEGAL_STRUCTURE_FAILURE = 'Unable to create Legal structure. Please try again.';

    // Messages for Survey Component.
    public static ADD_SURVEY_TEMPLATE_SUCCESS = 'Survey template added successfully.';
    public static DELETE_SURVEY_TEMPLATE_SUCCESS = 'Survey template deleted successfully.';
    public static UPDATE_SURVEY_TEMPLATE_SUCCESS = 'Survey template updated successfully.';
    public static SURVEY_TEMPLATE_FAILURE = 'Unable to process your request. Please try again.';

    // Messages for Survey Configuration Component.
    public static ADD_SURVEY_CONFIG_SUCCESS = 'Survey configuration added successfully.';
    public static DELETE_SURVEY_CONFIG_SUCCESS = 'Survey configuration deleted successfully.';
    public static UPDATE_SURVEY_CONFIG_SUCCESS = 'Survey configuration updated successfully.';
    public static SURVEY_CONFIG_FAILURE = 'Unable to process your request. Please try again.';

    // Messages for Survey Questions Component.
    public static ADD_SURVEY_QUESTION_SUCCESS = 'Survey question added successfully.';
    public static DELETE_SURVEY_QUESTION_SUCCESS = 'Survey question deleted successfully.';
    public static UPDATE_SURVEY_QUESTION_SUCCESS = 'Survey question updated successfully.';
    public static SURVEY_QUESTION_FAILURE = 'Unable to process your request. Please try again.';

    // Messages for Survey Responses
    public static CLEAR_SURVEY_QUESTION_RESPONSE_SUCCESS = 'Responses to the question cleared successfully.';
    public static REMOVE_OPTIONS = 'You can now remove the options.';
    public static DELETE_QUESTION = 'You can now delete the question.';
    public static CLEAR_SURVEY_QUESTION_RESPONSE_FAILURE = 'Unable to process your request. Please try again.';

    // Messages for Uploading Files
    public static UPLOAD_FILE_SUCCESS = 'File was uploaded successfully.';
    public static UPLOAD_FILE_FAILURE = 'Couldn\'t upload the file';

    // Messages for Search Placeholders
    public static CLIENT_SEARCH_PLACEHOLDER = 'Client Id...';
    public static HEADER_SEARCH_PLACEHOLDER = 'Search...';
    public static CLIENT_NAME_SEARCH_PLACEHOLDER = 'Client...';
    public static COUNTER_PARTY_SEARCH_PLACEHOLDER = 'Counter Party...';
    public static ARCHIVAL_ENTITY_SEARCH_PLACEHOLDER = 'Search entities for deletion...';
    public static ARCHIVAL_FIND_WITHOUT_RELATIONS = 'Find entities without relations';
    public static ARCHIVAL_WITH_SCREENING_HITS_ONLY = 'Only entities with screening hits';
    public static ARCHIVAL_WITH_NO_DOCUMENTS_ONLY = 'Only entities with no documents attached';
    public static ARCHIVAL_WITHOUT_RELATIONS_FAILURE = 'Unable to load entities without relations.';
    public static ARCHIVAL_ADD_ALL_TO_LIST = 'Add all to list';
    public static ARCHIVAL_NO_WITHOUT_RELATIONS = 'No entities without relations were found.';
    public static ORGANISATION_SEARCH_PLACEHOLDER = 'Search Offices...';

    // Messages for Payment Management
    public static SAVE_PAYMENT_ALERT = 'Are you sure you want to save payment? \n\n The transaction monitoring will be triggered.';
    public static DELETE_PAYMENT_ALERT = 'Do you want to delete the payment instruction?';
    public static ADD_PAYMENT_SUCCESS = 'Payment instruction added successfully.';
    public static ADD_PAYMENT_FAILURE = 'Unable to save new payment instruction. Please try again.';
    public static EDIT_PAYMENT_SUCCESS = 'Payment instruction edited successfully.';
    public static EDIT_PAYMENT_FAILURE = 'Unable to save edited payment instruction. Please try again.';
    public static DELETE_PAYMENT_SUCCESS = 'Payment instruction deleted successfully.';
    public static DELETE_PAYMENT_FAILURE = 'Unable to delete payment instruction. Please try again.';
    public static SYNC_CITCO_SUCCESS = 'CITCO transactions synced successfully.';
    public static SYNC_CITCO_FAILURE = 'Unable to sync CITCO transactions. Please try again.';

    // Messages for Bank Account & Institution Management
    public static ADD_BANK_INSTITUTION_SUCCESS = 'New bank institution added successfully.';
    public static ADD_BANK_INSTITUTION_FAILURE = 'Unable to add new bank institution. Please try again.';
    public static EDIT_BANK_INSTITUTION_SUCCESS = 'Bank institution details updated successfully.';
    public static EDIT_BANK_INSTITUTION_FAILURE = 'Unable to update bank institution. Please try again.';
    public static DELETE_BANK_INSTITUTION_ALERT = 'Are you sure you want to delete the bank institution?';
    public static DELETE_BANK_INSTITUTION_SUCCESS = 'Bank institution deleted successfully.';
    public static DELETE_BANK_INSTITUTION_FAILURE = 'Unable to delete bank institution. Please try again.';

    // Messages for Bank Account & Institution Management
    public static ADD_BANK_ACCOUNT_SUCCESS = 'New bank account added successfully.';
    public static ADD_BANK_ACCOUNT_FAILURE = 'Unable to add new bank account. Please try again.';
    public static EDIT_BANK_ACCOUNT_SUCCESS = 'Bank account details updated successfully.';
    public static EDIT_BANK_ACCOUNT_FAILURE = 'Unable to update bank account. Please try again.';
    public static DELETE_BANK_ACCOUNT_ALERT = 'Are you sure you want to delete the bank account?';
    public static DELETE_BANK_ACCOUNT_SUCCESS = 'Bank account deleted successfully.';
    public static DELETE_BANK_ACCOUNT_FAILURE = 'Unable to delete bank account. Please try again.';

    // Messages for Integration Management
    public static ADD_INTEGRATION_SUCCESS = 'New integration added successfully.';
    public static ADD_INTEGRATION_FAILURE = 'Unable to add new integration. Please try again.';
    public static EDIT_INTEGRATION_SUCCESS = 'Integration details updated successfully.';
    public static EDIT_INTEGRATION_FAILURE = 'Unable to update integration. Please try again.';
    public static DELETE_INTEGRATION_ALERT = 'Are you sure you want to delete the integration?';
    public static DELETE_INTEGRATION_SUCCESS = 'Integration deleted successfully.';
    public static DELETE_INTEGRATION_FAILURE = 'Unable to delete integration. Please try again.';

    // Messages for Archive Entity Component.
    public static ARCHIVAL_SUCCESS = 'Archival done successfully.';
    public static ARCHIVAL_FAILURE = 'Unable to archive. Please try again.';

    // Messages for Process Component.
    public static PROCESS_SUCCESS = 'Process updated successfully.';
    public static PROCESS_FAILURE = 'Unable to update proces. Please try again.';
    // File uploaded messages.
    public static PROCESS_FILE_UPLOAD_SUCCESS = 'Processes imported successfully.';
    public static PROCESS_FILE_UPLOAD_FAILURE = 'Unable to import processes. Please try again.';

    // Message for Rule Group.
    public static DELETE_RULE_GROUP_ALERT = 'Do you want to delete the Rule Group?';
    public static ADD_RULE_GROUP_SUCCESS = 'Rule Group added successfully.';
    public static ADD_RULE_GROUP_FAILURE = 'Unable to add Rule Group. Please try again.';
    public static UPDATE_RULE_GROUP_SUCCESS = 'Rule Group updated successfully.';
    public static DELETE_RULE_GROUP_SUCCESS = 'Rule Group deleted successfully.';
    public static DELETE_RULE_GROUP_FAILURE = 'Unable to delete rule group. Please try again.';

    // Message for Rule Group Functionality.
    public static DELETE_RULE_GROUP_FUNCTIONALITY_ALERT = 'Do you want to delete the Rule Group Functionality';
    public static ADD_RULE_GROUP_FUNCTIONALITY_SUCCESS = 'Rule Group Functionality added successfully.';
    public static ADD_RULE_GROUP_FUNCTIONALITY_FAILURE = 'Unable to add Rule Group Functionality. Please try again.';
    public static UPDATE_RULE_GROUP_FUNCTIONALITY_SUCCESS = 'Rule Group Functionality updated successfully.';
    public static DELETE_RULE_GROUP_FUNCTIONALITY_SUCCESS = 'Rule Group Functionality deleted successfully.';
    public static DELETE_RULE_GROUP_FUNCTIONALITY_FAILURE = 'Unable to delete rule group functionality. Please try again.';

    // Message for Rule.
    public static DELETE_RULE_ALERT = 'Do you want to delete the Rule?';
    public static ADD_RULE_SUCCESS = 'Rule added successfully.';
    public static ADD_RULE_FAILURE = 'Unable to add Rule. Please try again.';
    public static UPDATE_RULE_SUCCESS = 'Rule updated successfully.';
    public static DELETE_RULE_SUCCESS = 'Rule deleted successfully.';
    public static DELETE_RULE_FAILURE = 'Unable to delete rule. Please try again.';

    // Message for Rule Param.
    public static ADD_RULE_PARAM_SUCCESS = 'Rule Parameter added successfully.';
    public static ADD_RULE_PARAM_FAILURE = 'Unable to add Rule Parameter. Please try again.';
    public static UPDATE_RULE_PARAM_SUCCESS = 'Rule Parameter updated successfully.';
    public static UPDATE_RULE_PARAM_FAILURE = 'Unable to update Rule Parameter.';
    public static DELETE_RULE_PARAM_SUCCESS = 'Rule Parameter deleted successfully.';
    public static DELETE_RULE_PARAM_FAILURE = 'Unable to delete Rule Parameter. Please try again.';

    // Message for Tenant Configuration.
    public static DELETE_TENANT_SUBOFFICE_EXISTS = 'Tenant sub office already exists.';
    public static DELETE_TENANT_SUBOFFICE_SUCCESS = 'Tenant sub office deleted successfully.';
    public static DELETE_TENANT_SUBOFFICE_FAILURE = 'Unable to delete tenant sub office.';
    public static UPDATE_TENANT_CONFIGURATION_SUCCESS = 'Configuration updated succesfully.';
    public static UPDATE_TENANT_CONFIGURATION_FAILURE = 'Error while updating configurations.';
    public static UPDATE_TENANT_HEADOFFICE_SUCCESS = 'Tenant head office spdated succesfully.';
    public static UPDATE_TENANT_HEADOFFICE_FAILURE = 'Error while updating head office.';
    public static UPDATE_TENANT_SUBOFFICE_SUCCESS = 'Tenant sub office spdated succesfully.';
    public static UPDATE_TENANT_SUBOFFICE_FAILURE = 'Error while updating sub office.';


    // Messages for Client/Organisation Update.
    public static UPDATE_CLIENT_SUCCESS = 'Client details updated successfully.';
    public static UPDATE_CLIENT_FAILURE = 'Unable to update client details. Please try again.';
    public static UPDATE_ORGANISATION_SUCCESS = 'Organisation details updated successfully.';
    public static UPDATE_ORGANISATION_FAILURE = 'Unable to update organisation details. Please try again.';
    public static UPDATE_REVIEW_DATE_SUCCESS = 'Company review date updated successfully.';
    public static UPDATE_REVIEW_DATE_FAILURE = 'Unable to update company review date. Please try again.';
    public static OFFBOARD_CLIENT_SUCCESS = 'Client offboarding started, please complete outstanding tasks';
    public static OFFBOARD_CLIENT_FAILURE = 'Unable to offboard client. Please try again.';
    public static FETCH_SYSTEM_DIVISION_SUCCESS = 'Successfully fetched System Divisions.';
    public static FETCH_SYSTEM_DIVISION_FAILURE = 'Unable to fetch System Divisions. Please try again.';
    public static SELECT_SYSTEM_DIVISION_SUCCESS = 'System Division selected successfully.';
    public static SELECT_SYSTEM_DIVISION_FAILURE = 'Unable to select System Division. Please try again.';
    public static UPDATE_CLIENT_SERVICES_SUCCESS = 'Client services updated successfully.';
    public static UPDATE_CLIENT_SERVICES_FAILURE = 'Unable to update client services. Please try again.';
    public static UPDATE_DESCRIPTION_SUCCESS = 'Description updated successfully.';
    public static UPDATE_DESCRIPTION_FAILURE = 'Unable to update description. Please try again.';
    public static REMOVE_CLIENT_SERVICE_SUCCESS = 'Client service removed successfully.';
    public static REMOVE_CLIENT_SERVICE_FAILURE = 'Unable to remove client service. Please try again.';

    // Messages for Task Guide Text Update Component.
    public static TASK_GUIDE_TEXT_UPDATE_SUCCESS = 'Task guide text updated successfully.';
    public static TASK_GUIDE_TEXT_UPDATE_FAILURE = 'Unable to update task guide text. Please try again.';

    // Client Wtt/Wwft Onboard Messages
    public static ONBOARD_WTT_CLIENT_SUCCESS = 'Onboarding of WTT Client done successfully.';
    public static ONBOARD_WTT_CLIENT_FAILURE = 'Unable to Onboard WTT Client. Please try again.';
    public static ONBOARD_WWFT_CLIENT_SUCCESS = 'Onboarding of WWFT Client done successfully.';
    public static ONBOARD_WWFT_CLIENT_FAILURE = 'Unable to Onboard WWFT Client. Please try again.';

    // Messages for USER Management component.
    public static USER_UPDATE_FAILURE = 'Unable to update user details. Please try again.';

    // Messages for Comments.
    public static TASK_ADDED_SUCCESS = 'Task added successfully.';
    public static TASK_UPDATED_SUCCESS = 'Task updated successfully.';
    public static TASK_UPDATED_FAILURE = 'Unable to update task. Please try again.';
    public static ADD_COMMENT_SUCCESS = 'Comment added successfully.';
    public static ADD_COMMENT_FAILURE = 'Unable to add comment. Please try again.';
    public static REMOVE_COMMENT_SUCCESS = 'Comment removed successfully.';
    public static REMOVE_COMMENT_FAILURE = 'Unable to remove comment. Please try again.';
    public static TASK_SUBMIT_SUCCESS = 'Task submitted successfully.';
    public static TASK_SUBMIT_FAILURE = 'Unable to submit task. Please try again.';
    public static TASK_SUBMIT_CHOICE_SUCCESS = 'Task choice successfully.';
    public static TASK_SUBMIT_CHOICE_FAILURE = 'Unable to submit task choice. Please try again.';
    public static TASK_SAVE_FAILURE_DESCRIPTION = 'Unable to save task: Description longer than 4000 chars.';
    public static TASK_CHANGE_ALERT = 'A task is already open, are you sure you want to close the open task and open this task instead?';
    public static CANCEL_WORKFLOW_SUCCESS = 'cancel workflow successfully.';
    public static CANCEL_WORKFLOW_FAILURE = 'Unable to cancel workflow.Please try again.';
    public static TRANSACTION_STATUS_UPDATE_SUCCESS = 'Transaction status changed successfully.';
    public static TRANSACTION_STATUS_UPDATE_FAILURE = 'Unable to change transaction status.Please try again.';

    // Message(s) for Risk Profiles.
    public static ADD_RISK_PROFILE_SUCCES = 'New Risk Profile added successfully.';
    public static SUBMIT_RISK_PROFILE_SUCCES = 'Risk Profile submitted successfully.';

    // Messages for Group Component.
    public static ADD_GROUP_SUCCESS = 'Group added successfully.';
    public static DELETE_GROUP_SUCCESS = 'Group deleted successfully.';
    public static UPDATE_GROUP_SUCCESS = 'Group updated successfully.';
    public static GROUP_FAILURE = 'Unable to process your request. Please try again.';

    public static ERROR_MESSAGE = "Error occurred please try again.";

    // Messages for General Information Text Update Component.
    public static GENERAL_INFO_TEXT_UPDATE_SUCCESS = 'General Information updated successfully.';
    public static GENERAL_INFO_TEXT_UPDATE_FAILURE = 'Unable to update General Information. Please try again.';

    // Message(s) for Contact details.
    public static CONTACT_ADDED_SUCCESS = 'Contact added successfully.';
    public static CONTACT_UPDATED_SUCCESS = 'Contact updated successfully.';
    public static DELETE_CONTACT_SUCCES = 'Contact deleted successfully.';
    public static CONTACT_FAILURE = 'Unable to process your request. Please try again.';

    // Message(s) for Activity details.
    public static ADDED_ACTIVITY_SUCCESS = 'Activity added successfully.';
    public static DELETE_ACTIVITY_SUCCESS = 'Activity deleted successfully.';
    public static UPDATED_ACTIVITY_SUCCESS = 'Activity updated successfully.';
    public static UPDATED_ACTIVITY_SUMMARY_SUCCESS = 'Activity summary updated successfully.';
    public static ACTIVITY_FAILURE = 'Unable to process your request. Please try again.';

    // Messages for General Information Text Update Component.
    public static ADDRESS_INFO_ADD_SUCCESS = 'Address added successfully.';
    public static ADDRESS_INFO_UPDATE_SUCCESS = 'Address updated successfully.';
    public static ADDRESS_INFO_FAILURE = 'Unable to process your request. Please try again.';
    public static ADDRESS_DELETE_SUCCESS = 'Address deleted successfully.';
    public static ADDRESS_DELETE_FAILURE = 'Unable to delete address. Please try again.';

    // Messages for Uploading Entity Logos
    public static UPLOAD_LOGO_SUCCESS = 'Logo was uploaded successfully.';
    public static UPLOAD_LOGO_FAILURE = 'Couldn\'t upload the logo. Please try again.';

    // Message(s) for Document details.
    public static ADDED_DOCUMENT_SUCCESS = 'Document added successfully.';
    public static ADDED_DOCUMENT_LABELS_SUCCESS = 'Document labels added successfully.';
    public static UPDATED_DOCUMENT_SUCCESS = 'Document updated successfully.';
    public static DELETE_DOCUMENT_SUCCESS = 'Document deleted successfully.';
    public static DELETE_LABEL_SUCCESS = 'Document label deleted successfully.';
    public static DOCUMENT_FAILURE = 'Unable to process your request. Please try again.';
    public static SANCTION_RESOLVE_SUCCESS = 'Successfully updated sanction resolution.';
    public static SANCTION_RESOLVE_FAILURE = 'Unable to update sanction resolution. Please try again.';
    public static BADPRESS_RESOLVE_SUCCESS = 'Successfully updated badpress resolution.';
    public static BADPRESS_RESOLVE_FAILURE = 'Unable to update badpress resolution. Please try again.';
    public static PEP_RESOLVE_SUCCESS = 'Successfully updated pep resolution.';
    public static PEP_RESOLVE_FAILURE = 'Unable to update pep resolution. Please try again.';

    // Messages for Monitoring Elaboration Text Update Component.
    public static MONITORING_ELABORATION_TEXT_UPDATE_SUCCESS = 'Elaboration text updated successfully.';
    public static MONITORING_ELABORATION_TEXT_UPDATE_FAILURE = 'Unable to update Elaboration text. Please try again.';

    // Messages for Add Audit Information.
    public static ADD_AUDIT_DETAILS_SUCCESS = 'Audit details added successfully.';
    public static ADD_AUDIT_DETAILS_FAILURE = 'Unable to add Audit Details. Please try again.';

    // Message for Relationship.
    public static DELETE_RELATION_SUCCESS = 'Relation deleted successfully.';
    public static DELETE_RELATION_FAILURE = 'Unable to delete Relation. Please try again.';
    public static ADD_RELATION_SUCCESS = 'Relation added successfully.';
    public static UPDATED_RELATION_SUCCESS = 'Relation updated successfully.';
    public static UPDATED_EDIT_RELATION_SUCCESS = 'Relation comment updated successfully.';
    public static UPDATED_EDIT_RELATION_FAILURE = 'Unable to delete Relation. Please try again.';
    public static UPDATED_RELATION_FAILURE = 'Could not update relationship';
    public static UPDATED_REVERSE_RELATION_SUCCESS = 'Relation comment updated successfully.';
    public static UPDATED_REVERSE_RELATION_FAILURE = 'Unable to delete Relation. Please try again.';
    public static SELF_UBO_ERROR = 'Cannot select subject organisation itself as UBO.';
    public static ORG_UBO_ERROR = 'Cannot mark an organisation as UBO.';

    // Messages for PEP.
    public static ADD_PEP_SUCCESS = 'Added PEP Details successfully.';
    public static ADD_PEP_FAILURE = 'Unable to add Pep Details. Please try again.';

    // Transaction Profile messages.
    public static AGREEMENT_SAVE_SUCCESS = 'Agreement details saved successfully.';
    public static AGREEMENT_SAVE_FAILURE = 'Unable to Save Agreement details. Please try again.';
    public static ADD_RISK_SUCCESS = 'Risk details added successfully.';
    public static ADD_RISK_FAILURE = 'Unable to add risk details. Please try again.';
    public static UPDATE_RISK_SUCCESS = 'Risk details updated successfully.';
    public static UPDATE_RISK_FAILURE = 'Unable to update risk details. Please try again.';
    public static DELETE_RISK_SUCCESS = 'Risk details deleted successfully.';
    public static DELETE_RISK_FAILURE = 'Unable to delete risk details. Please try again.';
    public static RIGHT_SAVE_SUCCESS = 'Rights details saved successfully.';
    public static RIGHT_DELETE_SUCCESS = 'Rights details deleted successfully.';
    public static RIGHT_DELETE_FAILUR = 'Unable to delete Rights details. Please try again.';
    public static COUNTER_SAVE_SUCCESS = 'Counter party added successfully.';
    public static COUNTER_SAVE_FAILUR = 'Unable to add new counter party for Right. Please try again.';
    public static RIGHT_SAVE_FAILURE = 'Unable to Save Right details. Please try again.';
    public static OBLIGATION_SAVE_SUCCESS = 'Obligation details saved successfully.';
    public static OBLIGATION_SAVE_FAILURE = 'Unable to Save Obligation details. Please try again.';


    public static RISK_CONTROL_SUCCESS_TEMPLATE = 'Risk control %s successfully.';
    public static RISK_CONTROL_FAILURE_TEMPLATE = 'Unable to %s risk control. Please try again.';
    public static RISK_SUCCESS_TEMPLATE = 'Risk details %s successfully.';
    public static RISK_FAILURE_TEMPLATE = 'Unable to %s risk details. Please try again.';

    public static AGREEMENT_DELETE_SUCCESS = 'Agreement deleted successfully.';
    public static AGREEMENT_DELETE_FAILURE = 'Unable to process your request. Please try again.';

    public static DOCUMENT_DELETE_SUCCESS = 'Document deleted successfully.';
    public static DOCUMENT_DELETE_FAILURE = 'Unable to process your request. Please try again.';

    // Message for Alert in case of Monitoring Match for an entity.
    public static SANCTION_MATCH = '%s sanctioned by one or more countries';
    public static BAD_PRESS_MATCH = '%s bad press exposure';
    public static PEP_MATCH = '%s politically exposed person';

    public static TRANSACTION_DELETE_SUCCESS = 'Transaction deleted successfully.';
    public static TRANSACTION_DELETE_FAILURE = 'Unable to delete transaction. Please try again.';

    public static ADD_ADMIN_SERVICE_SUCCESS = 'Service added successfully.';
    public static DELETE_ADMIN_SERVICE_SUCCESS = 'Service deleted successfully.';
    public static DELETE_ADMIN_SERVICE_ALERT = 'Do you want to delete the selected service?';
    // As failure messages are being duplicated. In some upcoming MR, this
    // message should replace all above duplicate failure messages.
    public static ACTION_FAILURE = 'Unable to process the request. Please try again.';

    // Survey Response save messages.
    public static SAVE_SURVEY_RESPONSE_SUCCESS = 'Survey response saved successfully.';
    public static SAVE_SURVEY_RESPONSE_FAILURE = 'Unable to save survey response. Please try again later.';

    // Messages for Admin Service Remove Component.
    public static ADMIN_SERVICE_REMOVE_SUCCESS = 'Service removed successfully.';
    // Messages for ApplicationActivity Component.
    public static ADD_APPLICATION_ACTIVITY_SUCCESS = 'Application Activity added successfully.';
    public static DELETE_APPLICATION_ACTIVITY_SUCCESS = 'Application Activity deleted successfully.';
    public static UPDATE_APPLICATION_ACTIVITY_SUCCESS = 'Application Activity updated successfully.';
    public static APPLICATION_ACTIVITY_FAILURE = 'Unable to process your request. Please try again.';
    public static EMAILS_IMPORT_SUCCESSFULL = 'Emails Imported Successfully.';
    public static EMAILS_IMPORT_FAILURE = 'Unable To Import Emails';

    public static EMAILS_RETREIVED_SUCCESSFULL = 'Retreived Emails Successfully.';
    public static NO_MORE_EMAILS_TO_RETREIVE = 'No more email to be retreived.';
    public static EMAILS_RETREIVED_FAILURE = 'Failed To Retreived Emails';

    // Messages for Admin Rule Validation.
    public static RULE_VALIDATE_SUCCESSFULL = 'Rule Validated.';
    public static RULE_VALIDATE_FAILURE = 'Rule Validation Failed.';
    public static EMAILS_FAILED_TO_CONNECT = 'Failed To Connect with given credentials';

    public static TIME_KEEPING_DETAILS_SAVED_SUCCESSFULL = 'Time keeping details saved';
    public static TIME_KEEPING_DETAILS_SAVED_FAILURE = 'Failed to save Time keeping details';
}



// WEBPACK FOOTER //
// ./src/app/services/messages.service.ts